<div class="tree-container">
  <ng-container *ngIf="controlData?.leftTree">
    <div #left="fbcTree" class="left-tree" fbc-tree [formMapping]="controlData?.leftTree.formMapping" [hint]="controlData?.leftTree.hint | translate"
         [title]="controlData?.leftTree.title | translate" [height]="controlData?.leftTree.height"
         [idKey]="controlData?.leftTree.idKey" [displayKey]="controlData?.leftTree.displayKey"
         [disabled]="controlData?.leftTree?.disabled?.length > 0"
         [checkboxConfig]="controlData?.leftTree.checkboxConfig"
         (selectionChange)="onTreeSelectionChange($event)" [showRootNode]="controlData?.leftTree.showRootNode"></div>
  </ng-container>

  <div class="operation-buttons">
    <div class="buttons-panel">
      <button azure-id="right" [disabled]="leftTree?.disabled || rightTree?.disabled" mat-mini-fab (click)="moveToRight()">
        <span class="mdi mdi-chevron-right"></span>
      </button>
      <button azure-id="right-all" [disabled]="leftTree?.disabled || rightTree?.disabled" mat-mini-fab (click)="moveAllToRight()">
        <span class="mdi mdi-chevron-double-right"></span>
      </button>
      <button azure-id="left" [disabled]="leftTree?.disabled || rightTree?.disabled" mat-mini-fab (click)="moveToLeft()">
        <span class="mdi mdi-chevron-left"></span>
      </button>
      <button azure-id="left-all" [disabled]="leftTree?.disabled || rightTree?.disabled" mat-mini-fab (click)="moveAllToLeft()">
        <span class="mdi mdi-chevron-double-left"></span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="controlData?.rightTree">
    <div #right="fbcTree" class="right-tree" fbc-tree [formMapping]="controlData?.rightTree.formMapping" [hint]="controlData?.rightTree.hint | translate"
         [title]="controlData?.rightTree.title | translate" [height]="controlData?.rightTree.height"
         [idKey]="controlData?.rightTree.idKey" [displayKey]="controlData?.rightTree.displayKey"
         [disabled]="controlData?.rightTree?.disabled?.length > 0"
         [checkboxConfig]="controlData?.rightTree.checkboxConfig"
         (selectionChange)="onTreeSelectionChange($event)" [showRootNode]="controlData?.rightTree.showRootNode"></div>
  </ng-container>
</div>
